
<template>

  <div class="room-marquee room-mid chart-marquee">
    <div class="chart-toolbar">
      <div class="switcheroo">
        <div :class="chartType === 'line' ? 'roo-node roo-active' : 'roo-node'" @click="switchChartType">
          <h6>{{clauses.line}}</h6>
        </div>
        <div :class="chartType === 'column' ? 'roo-node roo-active': 'roo-node'" @click="switchChartType">
          <h6>{{clauses.col}}</h6>
        </div>
      </div>
      <div class="switch-range" v-if="granularity == 'sequential'">
        <a class="range-tog" @click="toggleRange(false)"><h3 style="margin-right:1.25px;"><</h3></a>
        <h5>{{cats[0]}} ~ {{cats[cats.length - 1]}}</h5>
        <a class="range-tog" @click="toggleRange(true)"><h3 style="margin-left:1.25px;">></h3></a>
      </div>
      <div class="switch-range" v-if="!trend">
        <a class="range-tog" @click="getOverallAdjacent('<')" v-if="cats.length == 31 || !cats.includes('12/12/2021')"><h3 style="margin-right:1.25px;"><</h3></a>
        <a class="range-tog" style="opacity:0" v-if="cats.length < 31 || cats.includes('12/12/2021')"></a>
        <h5 style="font-size:.75em;">{{cats[0]}} ~ {{cats[cats.length - 1]}}</h5>
        <a class="range-tog" @click="getOverallAdjacent('>')" v-if="validateLastDate('>')"><h3 style="margin-left:1.25px;">></h3></a>
        <a class="range-tog" style="opacity:0" v-if="!validateLastDate('>')"></a>
      </div>
    </div>
    <div id="chart"></div>
  </div>

</template>

<script>

// import { mapState } from 'vuex';
import moment from 'moment';
import axios from 'axios';
import Highcharts from 'highcharts';
import cToF from 'celsius-to-fahrenheit';
import fToC from 'fahrenheit-to-celsius';
import conv from 'convert-units';

import TestData from '@/lib/testData';

export default {

  data(){
    return {
      series: '',
      cats: [],
      overlay: false,
      chartType: 'line',
      granularity: '',
      tms: 0,
      gTrend: [],
      inactiveReadings: [],
      chart: {},
      initialEndDate: '',
      trendCrumbs: []
    }
  },

  props: ['trend', 'did'],

  computed: {
    room(){
      return this.$store.getters.getActiveRoom();
    },
    clauses(){
      const Room = require('@/lib/langTemplates/RoomTemplate');
      const Card = require('@/lib/langTemplates/CardTemplate');
      const lang = {...Room.clauses, ...Card.clauses};
      let lPref = this.$store.state.lang;
      return Object.keys(lang).reduce((a, i) => {
        a[i] = lang[i][lPref];
        return a;
      }, {});
    }
  },

  methods: {

    setChart() {
      const self = this;
      delete this.target;
      this.chart = {
        chart: {
          backgroundColor: 'none',
          style: {
            width: '100%',
            color: 'white'
          },
          type: this.chartType
        },
        title: false,
        xAxis: {
          categories: this.cats,
          units: '{this.term}',
          style: {
            color: 'white',
            fontFamily: 'Comfortaa'
          },
          labels: {
            style: {
              color: 'white',
              fontFamily: 'Comfortaa'
            }
          }
        },
        yAxis: [
          {
              title: {
                text: 'IAQ',
                style: {
                  color: 'red'
                }
              },
              opposite: false,
              labels: {
                style: {
                  color: 'red',
                  fontFamily: 'Comfortaa'
                },
              }
          },
          {
              title: {
                text: 'CO2',
                style: {
                  color: '#f7de2d'
                }
              },
              opposite: false,
              labels: {
                style: {
                  color: '#f7de2d',
                  fontFamily: 'Comfortaa'
                },
              }
          },
          {
            title: {
              text: 'tVOC',
              style: {
                color: '#377afc'
              }
            },
            opposite: true,
            labels: {
              style: {
                color: '#377afc',
                fontFamily: 'Comfortaa'
              },
            },
            min: 0.001,
            max: 1
          },
          {
            title: {
              text: 'Temp/Hum',
              style: {
                color: '#4ddf5a'
              }
            },
            opposite: true,
              labels: {
                style: {
                  color: '#4ddf5a',
                  fontFamily: 'Comfortaa',
                },
              },
              min: 0
            }
        ],
        plotOptions: {
          series: {
            cursor: 'pointer',
            events: {
              legendItemClick(event){
                const x = event.target.index
                if (!self.inactiveReadings.includes(x)) {
                  self.inactiveReadings.push(x);
                } else {
                  self.inactiveReadings = self.inactiveReadings.filter(ir => ir != x);
                }
              }
            },
            point: {
              events: {
                click(){
                  self.emitGranularTrendRequest(this.category)
                }
              }
            }
          },
          line: {
            dataLabels: {
              useHTML: true
            }
          }
        },
        tooltip: {
          text: '{this.title}: {point.y}{this.term}',
          shared: true
        },
        legend: {
          itemStyle: {
            color: 'white',
            fontFamily: 'Comfortaa'
          }
        },
        credits: false,
        series: this.series
      }
      if (!this.$store.state.user.metric) {
        let tSeries = this.chart.series.find(s => s.name == 'Temp');
        tSeries.data = tSeries.data.map(d => {
          d = typeof d == 'number' ? Math.round(cToF(d)) : null;
          return d;
        });
        tSeries.tooltip.valueSuffix = ' ˚F'
      }
      if (!this.$store.state.user.pressure) {
        let dprSeries = this.chart.series.find(s => s.name == 'Delta Pressure');
        dprSeries.data = dprSeries.data.map(d => {
          return parseFloat((d * .004).toFixed(3))
        });
        dprSeries.yAxis = 2;
        dprSeries.tooltip.valueSuffix = ' iwg';
      }
      this.inactiveReadings.forEach(rIndex => {
        this.chart.series[rIndex].visible = false;
      });
      // chart.xAxis.plotBands = this.trend ? addBands(this.series) : [];
      try {
        const dPressure = this.chart.series.find(ser => ser.name == 'Delta Pressure');
        if (dPressure && dPressure.data.every(dpr => !dpr)) this.chart.series.splice(this.chart.series.indexOf(dPressure), 1);
        this.target = Highcharts.chart('chart', this.chart);
      } catch(err) {
        console.log(err);
      }
    },

    validateLastDate(nextLast){
      if (nextLast == '>') {
        return !this.cats.includes(this.initialEndDate);
      }
    },

    async getOverallTrends(bookmark){
      const self = this;
      try {
        let raw = await getTrends(this.room.did, this.$cookies.get('breeziProTkn'), bookmark);
        if (raw.length < 5) {
            throw 'waiting';
          }
        let trends = raw.map(t => {
          let tre = {
            ttp: t.meas.htp,
            hhm: t.meas.hhm || null,
            iaq: t.meas.iaq,
            co2: t.meas.co2,
            voc: t.meas.voc ? (t.meas.voc <= 1 ? t.meas.voc : 1) : 0,
            tms: t.tms,
            dpr: t.meas.dpr
          }
          if (t.meas.voc) {
            tre.voc = t.meas.voc <= 0.734 ? t.meas.voc : 1;
          }
          if (t.meas.dpr) {
            // tre.dpr = this.$store.state.user.pressure ? tre.dpr : parseFloat((tre.dpr /= 249.082).toFixed(2));
          }
          return tre;
        }).sort((a, b) => {return a.tms - b.tms});
        // TODO: Show or don't show dpr trend based on isParent tag
        let series = ['ttp', 'hhm', 'iaq', 'co2', 'voc', 'dpr'].map(i => setAsyncSeries(trends, i, self.clauses));
        // let series = ['ttp', 'hhm', 'iaq', 'co2', 'voc'].map(i => setAsyncSeries(trends, i, self.clauses));
        let categories = setCats(trends);
        this.series = {
          categories: categories,
          series: series,
          async: true
        }
        this.cats = this.series.categories;
        this.series = this.series.series;
        this.series = this.series.reduce((validSeries, ser) => {
          ser.data = ser.data.filter(s => s);
          validSeries.push(ser);
          return validSeries;
        }, []);
        this.setChart();
        if (!bookmark) this.initialEndDate = this.cats[this.cats.length - 2]
      } catch(err) {
        console.log({ERROR: err});
        this.series = genSampleSeries(self.clauses).series;
        this.overlay = true;
        this.$emit('addOverlay');
        this.cats = this.series.categories;
        this.setChart();
      }
    },

    getOverallAdjacent(nextLast){
      try {
        const bookmarkIndex = nextLast == '>' ? this.cats.length - 1 : 0;
        const bmTms = `${nextLast}${Math.floor(new Date(this.cats[bookmarkIndex]).getTime()/1000)}`;
        this.getOverallTrends(bmTms);
      } catch(err) {
        this.getOverallTrends();
      }
    },

    getDayTrends(secondaryTrend){
      let trend = !secondaryTrend ? this.trend : secondaryTrend;
      trend = trend.reduce((a, i) => {
        if (!a.find(meas => meas.tms >= i.tms - 300 && meas.tms <= i.tms + 300)) a.push(i);
        return a;
      }, []);
      const self = this;
      this.cats = trend.map(t => moment(t.tms * 1000).format('hh:mm A'));
      this.series = ['ttp', 'hhm', 'iaq', 'co2', 'voc', 'dpr'].map(i => {
        let datapoint = switchName(i, self.clauses);
        datapoint.data = trend.map(t => t[i === 'ttp' ? 'htp' : i]) || [];
        // datapoint.data = trend.map(t => t[i !== 'ttp' ? i : 'htp']);
        switch (i) {
          case 'co2':
            datapoint.yAxis = 1;
          break;
          case 'iaq':
            datapoint.yAxis = 0;
          break;
          case 'voc':
            datapoint.yAxis = 2;
          break;
          case 'ttp':
            datapoint.yAxis = 3;
          break;
          case 'hhm':
            datapoint.yAxis = 3;
          break;
          case 'dpr':
            datapoint.yAxis = 2;
        }
        // if (i == 'dpr') {
        //   datapoint.data = datapoint.data.map(d => parseFloat((d /= 249.082).toFixed(2))) || [];
        // }
        if (i == 'dpr') datapoint.data = [];
        return datapoint;
      });
      this.setChart();
    },

    switchChartType(){
      this.chartType = this.chartType === 'line' ? 'column' : 'line';
      this.setChart();
    },

    async emitGranularTrendRequest(cat){
      if (this.granularity == 'day') {
        this.granularity = 'sequential';
        this.tms = this.$store.state.trendDayTms + additionalSeconds(cat);
        const room = this.$store.getters.getActiveRoom();
        const url = `https://3eunx8rcp7.execute-api.eu-west-1.amazonaws.com/dev/dailyTrends/${room.did}?start=${Math.floor(this.tms)}&sequential=initial`;
        this.$store.dispatch('updateBackLabel', 'Hourly');
        const headers = {
          'Content-Type': 'application/json',
          Authorization: this.$cookies.get('breeziProTkn')
        }
        try {
          this.gTrend = (await axios.get(url, {headers:headers})).data;
          if (this.gTrend.length) {
            this.getDayTrends(this.gTrend);
          }
        } catch(err) {
          console.log(err);
          // return {err: err};
        }
      } else {
        this.$emit('navDay', {tms: Math.floor(new Date(cat)/1000), granularity: this.granularity})
      }
    },

    async toggleRange(forward){
      const inRange = this.gTrend.filter(tPoint => forward ? tPoint.tms >= this.tms : tPoint.tms <= this.tms);
      const final = !forward ? inRange[0].tms : inRange[inRange.length - 1].tms;
      this.tms = final;
      const room = this.$store.getters.getActiveRoom();
      const url = `https://3eunx8rcp7.execute-api.eu-west-1.amazonaws.com/dev/dailyTrends/${room.did}?start=${final}&sequential=${forward ? 'proceed' : 'precede'}`;
      const headers = {
        'Content-Type': 'application/json',
        Authorization: this.$cookies.get('breeziProTkn')
      }
      try {
        const additional = (await axios.get(url, {headers:headers})).data;
        if (additional.length) {
          this.gTrend = inRange.concat(additional).sort((a, b) => a.tms - b.tms);
          this.getDayTrends(this.gTrend);
        }
      } catch(err) {
        console.log(err);
      }
    },

    adjustMetric(newData){
      try {
        const target = this.target;
        const temp = this.target.series.find(s => s.name == 'Temp');
        const tIndex = this.target.series.indexOf(temp);
        const convert = t => newData == false ? cToF(t) : fToC(t);
        let newTempData = temp.data.map(td => Math.round(convert(td.y)));
        this.target.series[tIndex].update({
          tooltip: {valueSuffix: ` ˚${newData ? 'C' : 'F'}`}
        });
        this.target.series[tIndex].setData(newTempData, true);
      } catch(err) {
        console.log({ err });
      }
    },

    adjustPressure(newData){
      const dpr = this.target.series.find(s => s.name == 'Delta Pressure');
      const dprIndex = this.target.series.indexOf(dpr);
      const convert = t => {
        let con = t;
        if (newData == true) {
          con = Math.round(t * 248.84);
        } else {
          con = parseFloat((t/248.84).toFixed(3));
        }
        return con;
      };
      let newDprData = dpr.data.map(dprd =>  convert(dprd.y));
      const updateParams = {
        tooltip: {valueSuffix: ` ${newData == true ? 'Pa' : 'iwg'}`},
        yAxis: newData == true ? 0 : 2
      };
      this.target.series[dprIndex].update(updateParams);
      this.target.series[dprIndex].setData(newDprData, true);
    }

  },

  mounted(){
    if (!this.trend) {
      this.getOverallTrends();
      this.granularity = 'overall';
    } else {
      this.getDayTrends();
      this.granularity = 'day';
    }
  },

  watch: {
    '$store.state.user.metric': function(newData, oldData){
      this.adjustMetric(newData);
    },
    '$store.state.user.pressure': function(newData, oldData){
      this.adjustPressure(newData);
    }
  }

}

function getTrends(did, tkn, bookmark){
  let url = 'https://3eunx8rcp7.execute-api.eu-west-1.amazonaws.com/dev/trends/' + did.toString();
  // let url = 'https://3eunx8rcp7.execute-api.eu-west-1.amazonaws.com/dev/mappedTrends/' + did.toString();
  if (bookmark) url += `?bookmark=${bookmark}`;
  const headers = {'Content-Type': 'application/json', Authorization: tkn};
  return new Promise((resolve, reject) => {
    axios.get(url, {headers: headers})
      .then(res => {
        resolve(res.data);
      }).catch(err => {
        reject(err);
      })
  })
}

function genSampleSeries(clauses){
  let trends = TestData();

  trends = trends.sort((a, b) => {return a.tms - b.tms});

  let categories = setCats(trends);
  let series = [];

  series.push(setSeries(trends, 'days', clauses));
  series.push(setSeries(trends, 'ttp', clauses));
  series.push(setSeries(trends, 'hhm', clauses));
  series.push(setSeries(trends, 'iaq', clauses));
  series.push(setSeries(trends, 'co2', clauses));
  series.push(setSeries(trends, 'dpr', clauses));
  let colours = ['#4ddf5a', '#e47f27', '#7f3be0', '#f7de2d', '#f60021', 'white'];
  series = series.map((s, x) => {
    s.color = colours[x];
    // s.color = '#777e74';
    return s;
  });

  return {
    categories: categories,
    series: series,
    async: false
  }
}

function setCats(trends){
  return trends.map(t => moment(t.tms * 1000).format('L'));
}

function setSeries(trends, prop, clauses){
  let trend = {
    name: switchName(prop, clauses).name,
    tooltip: switchName(prop, clauses).tooltip
  }
  if (prop === 'days'){
    trend.data = trends.map(t => t.dap.days);
  } else {
    trend.data = trends.map(t => t.meas[prop === 'ttp' ? 'htp' : prop]);
  }
  return trend;
}

function setAsyncSeries(trends, prop, clauses){
  let trend = switchName(prop, clauses);
  trend.data = trends.map(t => t[prop]);
  switch (prop) {
    case 'co2':
      trend.yAxis = 1;
    break;
    case 'iaq':
      trend.yAxis = 0;
    break;
    case 'voc':
      trend.yAxis = 2;
    break;
    case 'ttp':
      trend.yAxis = 3;
    break;
    case 'hhm':
      trend.yAxis = 3;
    break;
    case 'dpr':
      trend.yAxis = 0;
  }
  if (prop == 'voc') {
    trend.tooltip = {pointFormat: '{series.name}: {point.y:.3f}ppm<br/>'}
  }
  return trend;
}

function switchName(prop, clauses){
  switch (prop) {
    case 'days':
      return {name: clauses.daysRem, tooltip: {valueSuffix: clauses.days}};
    break;
    case 'ttp':
      return {name: clauses.temp, tooltip: {valueSuffix: ' ˚C'}, color: '#4ddf5a'};
    break;
    case 'hhm':
      return {name: clauses.hum, tooltip: {valueSuffix: ' %'}, color: '#7f3be0'};
    break;
    case 'iaq':
      return {name: 'IAQ', tooltip: {valueSuffix: ''}, color: '#f60021'};
    break;
    case 'co2':
      return {name: clauses.c2, tooltip: {valueSuffix: 'ppm'}, color: '#f7de2d'};
    break;
    case 'voc':
      // return {name: clauses.voc, tooltip: {valueSuffix: 'ppm'}, color: '#377afc'};
      return {name: 'tVOC', tooltip: {valueSuffix: 'ppm'}, color: '#377afc'};
    break;
    case 'dpr':
      return {name: 'Delta Pressure', tooltip: {valueSuffix: 'Pa'}, color: 'white'};
  }
}

function additionalSeconds(time){
  time = time.split(':');
  if (time[1].includes('PM')) {
    time[0] = parseInt(time[0]) + 12;
  }
  time[1] = parseInt(time[1].substring(0, 2)) * 60;
  time[0] = parseInt(time[0]) * 3600;
  return time[0] + time[1];
}

</script>

<style>

.chart-marquee {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.chart-toolbar {
  width: 100%;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
}

#chart {
  width: 100%;
  height: calc(100% - 55px);
  /* height: (9 / 16 * 100) + '%' */
}

.switch-range {
  width: 313px;
  height: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.range-tog {
  font-size: .75em;
  width: 17.5px;
  height: 17.5px;
  background: rgba(0,0,0,0);
  border: 2px solid rgb(0, 153, 191);
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  color: rgb(0, 153, 191);
  margin: 0px 30px 0px 30px;
}

.range-tog:hover {
  background: rgb(0, 153, 191);
  border: 2px solid #dce1ec;
  color: #dce1ec;
}

.switcheroo {
  width: 150px;
  height: 25px;
  position: absolute;
  top: 0px;
  left: 1%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  border: 1px solid rgb(0, 153, 191);
}

.roo-node {
  width: 50%;
  height:100%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.roo-active {
  background-color: rgb(0, 153, 191);
}

.roo-node h6 {
  margin: 0px;
}

</style>



// WEBPACK FOOTER //
// src/components/room/Chart.vue